export default "__VITE_ASSET__D$joI79w__"